import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {Error404Component} from "./404.component";


@NgModule({
  declarations: [Error404Component],
  imports     : [BrowserModule],
  exports     : [Error404Component],
})

export class ErrorsModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/errors/errors.module.ts